import { useEffect } from 'react'
import { useRouteError } from 'react-router'
import * as Sentry from '@sentry/react'
import { logger } from '../next/lib/sentry'

/**
 * Plain HTML/CSS error boundary (no Chakra dependencies)
 * This allows us to avoid loading Chakra v2 on initial page load
 */
export const PlainErrorBoundary = () => {
  const error = useRouteError()

  useEffect(() => {
    if (error) {
      logger.error('ErrorBoundary Error', error as any)
      Sentry.captureException(error)
    }
  }, [error])

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        fontFamily:
          'Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, sans-serif',
        backgroundColor: '#fafafa',
        padding: '20px',
      }}
    >
      <div
        style={{
          textAlign: 'center',
          maxWidth: '500px',
        }}
      >
        <h1
          style={{
            fontSize: '20px',
            fontWeight: '600',
            color: '#18181b',
            marginBottom: '8px',
          }}
        >
          Something went wrong :(
        </h1>
        <p
          style={{
            fontSize: '14px',
            color: '#71717a',
            marginBottom: '24px',
          }}
        >
          Please refresh the page or try again later.
        </p>

        <a
          href="/ship"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            padding: '0',
            background: 'none',
            border: 'none',
            color: '#71717a', // Muted gray color to match Chakra's variant="link"
            fontSize: '14px',
            fontWeight: '500',
            cursor: 'pointer',
            textDecoration: 'none',
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.textDecoration = 'underline'
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.textDecoration = 'none'
          }}
          onFocus={(e) => {
            e.currentTarget.style.textDecoration = 'underline'
          }}
          onBlur={(e) => {
            e.currentTarget.style.textDecoration = 'none'
          }}
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <line x1="19" y1="12" x2="5" y2="12"></line>
            <polyline points="12 19 5 12 12 5"></polyline>
          </svg>
          Go back
        </a>
      </div>
    </div>
  )
}
